import React from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../helpers/constants";

const Page404 = () => {
	const navigate = useNavigate();

	return (
		<div className="signup-process main-layout py-4 md:p-5 h-screen">
			<div className="container h-full">
				<div className="signup-process-wrapper bg-[#4271D5] rounded-[20px] relative py-[32px] pb-[50px] px-[15px] md:p- 
				[32px] h-full">
					<div className="h-full flex flex-col justify-center items-center sm:py-[40px] md:py-[100px] signup- 
					process-content-wrapper">
						<div className="signup-process-content flex flex-col gap-5 h-full justify-center items-center w-full  
						md:w-3/4 lg:w-2/3 xl:w-1/2 mx-auto">
							<h1 className="font-bold text-9xl text-blue mb-0">404</h1>
							<button
								className="btn-light-gray text-[24px] px-[15px] py-[20px]"
								onClick={() => navigate(routes.dashboard)}
							>
								Back to Dashboard
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Page404;
